import type {
  FundHolding,
  HoldingsSummary,
  PortfolioCompany,
  RawFundHolding,
  RawHoldingsSummary,
  RawPortfolioCompany,
} from './types';
import { toNumber, toNumberOrNull } from '@/utils/number-operations';

function mapPortfolioCompany(raw: RawPortfolioCompany): PortfolioCompany {
  return {
    id: raw.id,
    name: raw.name,
    website: raw.website,
    sector: raw.sector,
    fund_id: raw.fund_id,
    fund_name: raw.fund_name,
    total_investment_by_fund: toNumber(raw.total_investment_by_fund),
    ownership_percentage: toNumberOrNull(raw.ownership_percentage),
    lp_investment_amount: toNumber(raw.lp_investment_amount),
    current_value: toNumber(raw.current_value),
    unrealized_gain_loss: toNumber(raw.unrealized_gain_loss),
    returns_multiple: toNumber(raw.returns_multiple),
    investment_date: raw.investment_date,
    status: raw.status,
  };
}

function mapFundHolding(raw: RawFundHolding): FundHolding {
  return {
    id: raw.id,
    name: raw.name,
    display_name: raw.display_name,
    vintage_year: raw.vintage_year,
    status: raw.status,
    base_currency: raw.base_currency,
    commitment_amount: toNumber(raw.commitment_amount),
    total_called: toNumber(raw.total_called),
    total_distributed: toNumber(raw.total_distributed),
    nav: toNumberOrNull(raw.nav),
    call_percentage: toNumber(raw.call_percentage),
    prepayment_pool: toNumber(raw.prepayment_pool),
    portfolio_company_count: raw.portfolio_company_count,
    information_as_of: raw.information_as_of,
  };
}

export function mapHoldingsSummary(raw: RawHoldingsSummary): HoldingsSummary {
  return {
    total_commitment: toNumber(raw.total_commitment),
    total_called: toNumber(raw.total_called),
    total_prepayment_pool: toNumber(raw.total_prepayment_pool),
    portfolio_value: toNumberOrNull(raw.portfolio_value),
    unrealized_gain: toNumberOrNull(raw.unrealized_gain),
    fund_count: raw.fund_count,
    hidden_fund_count: raw.hidden_fund_count,
    information_as_of: raw.information_as_of,
    funds: raw.funds.map(mapFundHolding),
    companies: raw.companies.map(mapPortfolioCompany),
  };
}

export function mapFundHoldingResponse(raw: RawFundHolding): FundHolding {
  return mapFundHolding(raw);
}

export function mapPortfolioCompanies(
  raw: RawPortfolioCompany[]
): PortfolioCompany[] {
  return raw.map(mapPortfolioCompany);
}
